import { Stack } from "@mui/material";
import React from "react";
import originalImage from "./sad1.png";
import modifiedImage from "./happy1.png";
import SliderBackgroundImg from "./SliderBackImg.jpeg";
import PulseAnimation2 from "../Section/SliderComponent/PulseAnimation2";
import ReactCompareImage from "react-compare-image";
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from "react-compare-slider";

const Test_com = () => {
  return (
    <Stack>
      <ReactCompareSlider
        itemOne={
          <ReactCompareSliderImage
            src={originalImage}
            srcSet={originalImage}
            alt="Image one"
          />
        }
        itemTwo={
          <ReactCompareSliderImage
            src={modifiedImage}
            srcSet={modifiedImage}
            alt="Image two"
          />
        }
        handle={<PulseAnimation2 />} // Pass the custom handle here
        //  handle={<>tt</>} // Pass the custom handle here
      />
    </Stack>
  );
};

export default Test_com;
